import { WidgetLayout } from 'components/WidgetLayout'
import { getAreaIdSearchParams, getAreaSlugSearchParams } from 'utils/query-params'
import { useMemo } from 'react'
import { useGetIsPortalHidden } from 'hooks/useGetIsPortalHidden'
import { useGetAreaBySlug } from 'api/areas'

export const WidgetPage = () => {
  const areaId = useMemo(getAreaIdSearchParams, [])
  const areaSlug = useMemo(getAreaSlugSearchParams, [])
  const isPortalHidden = useGetIsPortalHidden()

  // Intermediate step: resolve the area slug to its id so the rest of the
  // widget keeps working with areaId as before.
  const { area, isLoading: isResolvingSlug } = useGetAreaBySlug(areaSlug)

  if (isPortalHidden) {
    return null
  }

  // Wait for the slug to resolve before mounting the layout, so it mounts once
  // with the final areaId instead of switching from undefined.
  if (areaSlug && isResolvingSlug) {
    return null
  }

  const resolvedAreaId = areaSlug ? area?._id : areaId

  return <WidgetLayout areaId={resolvedAreaId} />
}
